"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var z = __importStar(require("./base")); // import { ZodUndefined } from './undefined';
// import { ZodNull } from './null';
// import { ZodUnion } from './union';


var ZodError_1 = require("../ZodError");

var errorUtil_1 = require("../helpers/errorUtil");

var emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
var uuidRegex = /([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}){1}/i;

var ZodString =
/** @class */
function (_super) {
  __extends(ZodString, _super);

  function ZodString() {
    // opt optional: () => ZodUnion<[this, ZodUndefined]> = () => ZodUnion.create([this, ZodUndefined.create()]);
    var _this = _super !== null && _super.apply(this, arguments) || this; // null nullable: () => ZodUnion<[this, ZodNull]> = () => ZodUnion.create([this, ZodNull.create()]);


    _this.toJSON = function () {
      return _this._def;
    };

    _this.min = function (minLength, message) {
      return _this._refinement(__assign({
        check: function check(data) {
          return data.length >= minLength;
        },
        code: ZodError_1.ZodErrorCode.too_small,
        minimum: minLength,
        type: 'string',
        inclusive: true
      }, errorUtil_1.errorUtil.errToObj(message)));
    };

    _this.max = function (maxLength, message) {
      return _this._refinement(__assign({
        check: function check(data) {
          return data.length <= maxLength;
        },
        code: ZodError_1.ZodErrorCode.too_big,
        maximum: maxLength,
        type: 'string',
        inclusive: true
      }, errorUtil_1.errorUtil.errToObj(message)));
    };

    _this._regex = function (regex, validation, message) {
      return _this._refinement(__assign({
        validation: validation,
        code: ZodError_1.ZodErrorCode.invalid_string,
        check: function check(data) {
          return regex.test(data);
        }
      }, errorUtil_1.errorUtil.errToObj(message)));
    };

    _this.email = function (message) {
      return _this._regex(emailRegex, 'email', message);
    };

    _this.url = function (message) {
      return _this._refinement(__assign({
        check: function check(data) {
          try {
            new URL(data);
            return true;
          } catch (_a) {
            return false;
          }
        },
        code: ZodError_1.ZodErrorCode.invalid_string,
        validation: 'url'
      }, errorUtil_1.errorUtil.errToObj(message)));
    }; // url = (message?: errorUtil.ErrMessage) => this._regex(urlRegex, 'url', message);


    _this.uuid = function (message) {
      return _this._regex(uuidRegex, 'uuid', message);
    };

    _this.regex = function (regexp, message) {
      return _this._regex(regexp, 'regex', message);
    };

    _this.nonempty = function (message) {
      return _this.min(1, errorUtil_1.errorUtil.errToObj(message));
    };

    return _this;
  }

  ZodString.prototype.length = function (len, message) {
    return this.min(len, message).max(len, message);
  };

  ZodString.create = function () {
    return new ZodString({
      t: z.ZodTypes.string,
      validation: {}
    });
  };

  return ZodString;
}(z.ZodType);

exports.ZodString = ZodString;